module.exports = __webpack_public_path__ + "static/img/newsa.f56f7e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsa.png
// module id = X9pU
// module chunks = 45